import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";

export const ICON_EXPANDED: DSIconName = "arrow-up";
export const ICON_COLLAPSED: DSIconName = "arrow-down";
